import { styled } from "@mui/material";
import { Box } from "@mui/system";

export const FlexBox = styled(Box)({
  display: "flex",
});
